import React from "react";

export const SkeletonMenu: React.FC = () => {
  const numberMenuString = 5;

  return (
    <div className="flex flex-col gap-5 px-2 mt-4">
      {Array(numberMenuString)
        .fill(0)
        .map((_item, index) => (
          <div
            key={index}
            className="text-gray-300 bg-primary-700 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
          >
            <p className="w-full"></p>
          </div>
        ))}
    </div>
  );
};
